import React, { useContext } from 'react'
import Context from '../context/Context'

const Footer = () => {
  const context = useContext(Context)

  return (
    <div>
      <div className="row mt-5">
        <div className="hr-div">
          <div className="hr"></div>
        </div>
      </div>
      <div className="row mt-3 footer">
        <div className="col-12 text-center">
          <span className="paragraph-bold-18">{context.organizationSettings.organizationName}</span><br />
          <span className="paragraph-regular-14">{context.organizationSettings.postalAddress}, {context.organizationSettings.postalZipCodeCity}</span><br />
          <a href={ `mailto:${context.organizationSettings.email}` }>
            <span className="paragraph-regular-14">{context.organizationSettings.email}</span>
          </a>
        </div>
        <div className="ml-3">
          <span className="footer-zavann-company">&copy;Zavann</span>
        </div>
      </div>
    </div>
  )
}

export default Footer
